import {
	IconCheckOutline18 as Check,
	IconCircleCheckOutline18 as CheckCircle,
	IconCircleXmarkOutline18 as XCircle,
} from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "@/components/filters"
import { useContactsFilterState } from "../contacts-filter-state"

export const SUBSCRIPTION_OPTIONS: {
	value: boolean
	label: string
	Icon: typeof CheckCircle
}[] = [
	{ value: true, label: "Subscribed", Icon: CheckCircle },
	{ value: false, label: "Unsubscribed", Icon: XCircle },
]

export function SubscriptionFilterItems({ onSelect }: SharedFilterItemsProps) {
	const { subscribedStates, addSubscribedState, removeSubscribedState } =
		useContactsFilterState()

	return (
		<>
			{SUBSCRIPTION_OPTIONS.map(({ value, label, Icon }) => {
				const isSelected = subscribedStates.includes(value)
				return (
					<CommandItem
						key={label}
						onSelect={() => {
							if (isSelected) {
								removeSubscribedState(value)
							} else {
								addSubscribedState(value)
							}
							onSelect()
						}}
					>
						<div className="flex w-full items-center gap-2">
							<Icon className="h-4 w-4 shrink-0 text-secondary" />
							<span className="flex-1 truncate">{label}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
